import { render, staticRenderFns } from "./AdminResponsible.vue?vue&type=template&id=522dbfb8&scoped=true&"
import script from "./AdminResponsible.vue?vue&type=script&lang=js&"
export * from "./AdminResponsible.vue?vue&type=script&lang=js&"
import style0 from "./AdminResponsible.vue?vue&type=style&index=0&id=522dbfb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522dbfb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VDataTable,VIcon,VSpacer,VTextField})
